import React from 'react';

const CreditCardAlert = (props) => {
    return (
        <div className='credit-card-alert-block'>
            <span className='title'>
                <a href={props.link} target='_blank'>{props.title}</a>
            </span>
        </div>

    );
};
export default CreditCardAlert;
